document.addEventListener('DOMContentLoaded', () => {
  const ctaWrappers = document.querySelectorAll('.footer-sticky-ctas-wrapper');

  if (ctaWrappers) {
    function adjustStickyCtas(evt) {
      ctaWrappers.forEach(ctaWrapper => {
        let cta = ctaWrapper.querySelector('.footer-sticky-ctas');
        let ctaHeight = ctaWrapper.classList.contains('d-none') ? 0 : cta.clientHeight; // Unsticky mobile when scrolled past its sticky item height
        if ((document.scrollingElement.scrollTop + document.scrollingElement.clientHeight) > (ctaWrapper.offsetTop + ctaHeight)) {
          ctaWrapper.classList.add('attached')
        } else {
          ctaWrapper.classList.remove('attached')
        }
      })
    }

    window.addEventListener('scroll', adjustStickyCtas);
    window.addEventListener('resize', adjustStickyCtas);
    adjustStickyCtas();
  }
});